import {useCallback, useRef, useState} from 'react'
import {ProviderMeasurement, runPreferredMeasurement} from './providers'

export type ConnectionTestMeasurement = ProviderMeasurement

export function useConnectionTest() {
  const [isRunning, setIsRunning] = useState(false)
  const abortRef = useRef<AbortController | null>(null)

  const runTest = useCallback(async (): Promise<ConnectionTestMeasurement> => {
    abortRef.current?.abort()
    const controller = new AbortController()
    abortRef.current = controller

    setIsRunning(true)
    try {
      return await runPreferredMeasurement(controller.signal)
    } finally {
      setIsRunning(false)
      if (abortRef.current === controller) abortRef.current = null
    }
  }, [])

  const cancel = useCallback(() => {
    abortRef.current?.abort()
  }, [])

  return {runTest, isRunning, cancel}
}
